import { RootState } from 'store/rootReducer'

export const getYaPayFeatureConfig = (state: RootState) => state.app.YANDEX_PAY
